// extracted by mini-css-extract-plugin
export var boxItems = "_81-1";
export var button = "_81-5";
export var filterGroupBox = "_81-0";
export var icon = "_81-2";
export var iconSecondary = "_81-4";
export var iconWrapper = "_81-3";